<template>
  <div class="commercial-wrapper">
    <div class="commercial section">
      <div class="commercial-inner">
        <div class="container">
          <h2 class="section-title">
            Dlaczego my?
          </h2>
          <div class="commercial-items columns">
            <div class="column">
              <div class="commercial-item">
                <div class="commercial-item__icon">
                  <icon name="fa-business-time" />
                </div>
                <p class="commercial-item__title is-size-4">Doświadczenie</p>
                <div class="commercial-item__content">
                  Jesteśmy najdłużej działającym operatorem telewizji kablowej i
                  dostawcą internetu w Oławie. Działamy na oławskim rynku już 30
                  lat!
                </div>
              </div>
            </div>
            <div class="column">
              <div class="commercial-item">
                <div class="commercial-item__icon">
                  <icon name="fa-network-wired" />
                </div>
                <p class="commercial-item__title is-size-4">Infrastruktura</p>
                <div class="commercial-item__content">
                  Inwestujemy w nowoczesną infrastrukturę światłowodową i stale
                  modernizujemy naszą sieć.
                </div>
              </div>
            </div>
            <div class="column">
              <div class="commercial-item">
                <div class="commercial-item__icon">
                  <icon name="fa-tools" />
                </div>
                <p class="commercial-item__title is-size-4">Niezawodność</p>
                <div class="commercial-item__content">
                  Dysponujemy własnym, szybkim i skutecznym serwisem w usuwaniu
                  awarii.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <svg class="delimiter" viewBox="0 0 100 30" preserveAspectRatio="none">
      <g transform="translate(0,-197)">
        <rect
          class="delimiter__body"
          width="100"
          height="22.449968"
          x="0"
          y="197"
        />
        <path
          class="delimiter__wave"
          d="m -0.13363476,198.80986 c 0,0 4.55059226,3.91736 15.16411176,8.34454 C 68.547993,224.66187 68.460906,191.26162 100,206.24443 v 13.23305 H 0 Z"
        />
        <path
          class="delimiter__wave"
          d="m -0.13363476,206.14994 c 0,0 13.99999676,-4.55665 24.61351676,-0.12947 C 78.091892,227.02422 83.406026,202.58465 100,197 v 22.47748 H 0 Z"
        />
        <path
          class="delimiter__after"
          d="M -0.13363476,211.84983 C 33.239703,196.51903 66.424622,234.4702 100,211.84983 l 0,8.65724 H 0 Z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "commercial",

  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
.commercial {
  padding-top: 100px;
  background-color: $primary;
}

.delimiter {
  height: 25vw;
  width: 100%;

  &__body {
    fill: $primary;
  }

  &__wave {
    fill: $black;
    fill-opacity: 0.2;
  }

  &__after {
    fill: $white;
  }
}

.commercial-item {
  @include until($tablet) {
    margin-bottom: 50px;
  }

  &__icon {
    text-align: center;
  }

  &__title {
    text-align: center;
    text-transform: uppercase;
    font-family: $family-sans-serif-wide;
    font-weight: 900;
    color: $white;
    user-select: none;
  }

  &__content {
    color: $white;
    font-family: $family-sans-serif-condensed;
    text-align: center;
    font-style: italic;
    font-weight: 600;

    padding: {
      left: 1rem;
      right: 1rem;
    }

    @include mobile {
      padding: {
        left: 5rem;
        right: 5rem;
      }
    }

    @include until($small-mobile) {
      padding: {
        left: 0.4rem;
        right: 0.4rem;
      }
    }
  }
}

.icon {
  color: $white;
  font-size: 6rem;

  @include mobile {
    font-size: 5rem;
  }
}
</style>
